import {
  CURRENT_LIVING_SITUATION,
  existingProgramEnrollments,
  programTypes,
  REFERRAL_STATUS,
  referralProgramOptions,
  referringProviderOptions,
} from "constants/common";
import { useEffect, useState, useRef } from "react";
import { getOrganization, getOrganizations } from "containers/community/api";
import { initialMetaForTable, DEBOUNCE_DELAY } from "constants/common";
import AsyncSelect from "components/common/select/AsyncSelect";
import debounce from "lodash/debounce";
import { getHealthPlans } from "containers/policies/api";
import { useDebouncedHealthPlansDataCallback } from "utils/debouncedHelper";
import moment from "moment";
import CopyLink from "components/common/copy-link/CopyLink";
import { DownloadSimple } from "phosphor-react";
const { default: DateInput } = require("components/common/date-picker");
const { default: Input } = require("components/common/input");
const { default: SelectComponent } = require("components/common/select");
const {
  referralWithMemberInitialValues,
  referralWithMemberValidationSchema,
} = require("constants/referrals");
const { Formik, ErrorMessage } = require("formik");

const useDebouncedFetchOrganizations = () => {
  const debouncedFetch = useRef(
    debounce(async (inputValue, callback) => {
      try {
        const response = await getOrganizations({
          search: inputValue,
        });

        let formattedOptions = response?.community_engagements?.map((el) => ({
          ...el,
          value: el.id,
          label: el.name,
        }));

        if (!formattedOptions || formattedOptions.length === 0) {
          callback([]);
        } else {
          callback(formattedOptions);
        }
      } catch (error) {
        console.error("Failed to fetch members:", error);
        callback([]);
      }
    }, DEBOUNCE_DELAY)
  ).current;

  return debouncedFetch;
};

const AddFromWithMember = ({
  handleAddReferral,
  handleCloseAddModal,
  selectedMember,
  selectedReferral,
}) => {
  const [organizationList, setOrganizationList] = useState([]);
  const [healthPlansList, setHealthPlansList] = useState([]);
  const [selectedReferralSource, setSelectedReferralSource] = useState("");
  const fetchHealthPlan = async (searchString) => {
    const result = await getHealthPlans({
      ...initialMetaForTable,
      search: searchString,
    });

    if (result["health_plans"]) {
      const data = result?.health_plans;
      setHealthPlansList(data);
    }
  };
  useEffect(() => {
    fetchHealthPlan();
  }, []);
  const debouncedHealthPlansDataCallback = useDebouncedHealthPlansDataCallback();
  const debouncedFetchOrganizationData = useDebouncedFetchOrganizations();

  useEffect(() => {
    (async () => {
      const result = await getOrganizations({
        ...initialMetaForTable,
        page: 1,
      });
      if (result?.community_engagements) {
        let data = result?.community_engagements;
        const findCommunity = result?.community_engagements.find(
          (ele) => ele.id === selectedReferral?.community_engagement_id
        );
        if (!findCommunity) {
          const organization = await getOrganization(
            selectedReferral?.community_engagement_id
          );
          if (organization?.community_engagement)
            data = [...data, organization.community_engagement];
        }
        if (selectedReferral) {
          const selectedOrganization = data.find(
            (org) => org.id === selectedReferral.community_engagement_id
          );
          setSelectedReferralSource(selectedOrganization);
        }
        setOrganizationList(data);
      }
    })();
  }, []);

  const convertFileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  return (
    <Formik
      initialValues={referralWithMemberInitialValues(
        selectedReferral ? selectedReferral : selectedMember
      )}
      validationSchema={referralWithMemberValidationSchema}
      enableReinitialize
      onSubmit={async (values, { setErrors }) => {
        const approved_referrals_attributes = {};
        let base64Document = null;

        console.log(
          "Attachment type:",
          typeof values.attachment,
          values.attachment
        );
        console.log("Is instance of File?", values.attachment instanceof File);
        if (values.attachment) {
          base64Document = await convertFileToBase64(values.attachment);
        }
        handleAddReferral(
          {
            ...values,
            auth_number: values.auth_number,
            approved_days: values.approved_days,
            start_date: moment(values.start_date).format("YYYY-MM-DD"),
            end_date: moment(values.end_date).format("YYYY-MM-DD"),
            member_id: selectedMember.id,
            programe_enrollement:
              values?.programe_enrollement?.map((item) => item?.value || "") ||
              [],

            attachment: base64Document,
          },
          setErrors
        );
      }}
    >
      {({ handleChange, values, handleSubmit, setFieldValue }) => {
        // const selectedOrganization = organizationList.find(
        //   (org) => org.id === values.community_engagement_id
        // );
        // const referralProviderOptions = selectedOrganization
        //   ? selectedOrganization.organization_contacts.map((contact) => ({
        //       value: contact.id,
        //       label: contact.name,
        //     }))
        //   : [];
        return (
          <div className="question-modal">
            <form className="form-main" onSubmit={handleSubmit}>
              <hr className="custom-modal-line mt-0 " />

              <div className="input-flex row">
                <div className="col-sm-6">
                  <Input
                    handleChange={handleChange}
                    placeholder="e.g. Michael Johnson"
                    type="text"
                    label="Name"
                    value={values.fullName}
                    name="name"
                    disabled
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="name"
                      />
                    }
                  />
                </div>

                <div className=" col-sm-6">
                  <DateInput
                    handleChange={(date) => {
                      setFieldValue("date_of_birth", date);
                    }}
                    value={values.date_of_birth}
                    label="Date of Birth"
                    name="date_of_birth"
                    placeholder="Date of Birth"
                    disabled
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="date_of_birth"
                      />
                    }
                  />
                </div>
              </div>

              <div className="input-flex row">
                <div className="col-sm-6">
                  <Input
                    handleChange={handleChange}
                    placeholder="CIN"
                    type="text"
                    label="CIN"
                    value={values.cin}
                    name="cin"
                    disabled
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="cin"
                      />
                    }
                  />
                </div>
                <div className="col-sm-6 ">
                  <Input
                    disabled
                    handleChange={handleChange}
                    placeholder="e.g. AICA256849317"
                    type="text"
                    label="FHIR ID"
                    value={values.aica_account}
                    name="aica_account"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="aica_account"
                      />
                    }
                  />
                </div>
                <div>
                  <AsyncSelect
                    label="Health Plan"
                    isRequired
                    options={
                      healthPlansList.find(
                        (el) => el.id === selectedMember.health_plan_id
                      ) || typeof selectedMember.health_plan_id == "undefined"
                        ? healthPlansList?.map((el) => {
                            return { value: el.id, label: el.name };
                          })
                        : [
                            ...healthPlansList?.map((el) => {
                              return { value: el.id, label: el.name };
                            }),
                            {
                              value: selectedMember.health_plan?.id,
                              label: selectedMember.health_plan?.name,
                            },
                          ]
                    }
                    loadOptions={(inputValue) =>
                      new Promise((resolve) => {
                        debouncedHealthPlansDataCallback(inputValue, resolve);
                      })
                    }
                    selectedValue={values.health_plan_id}
                    placeholder="Select Health Plan "
                    handleChange={(obj) => {
                      setFieldValue("health_plan_id", obj.value);
                    }}
                    isDisabled
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="health_plan_id"
                      />
                    }
                  />
                </div>
                <hr className="custom-modal-line mt-4 " />
                <h4 className=" my-4">Referral Information</h4>
                {selectedMember?.addresses?.find(
                  (a) =>
                    a.address_type === "mailing" &&
                    a.county_id == process.env.REACT_APP_COUNTY_ID
                ) && (
                  <div className="input-flex row">
                    <div className="col-sm-6">
                      <h6>SPA Code:</h6>
                    </div>
                    <div className="col-sm-6">
                      {selectedMember?.spa_code ===
                      "Zip Code does not have assigned SPA Number" ? (
                        <p className="error-message">
                          {selectedMember?.spa_code}
                        </p>
                      ) : (
                        <p>{selectedMember?.spa_code}</p>
                      )}
                    </div>
                  </div>
                )}

                <div className="input-flex row">
                  <div className="col-sm-6">
                    <SelectComponent
                      isRequired
                      label="Referral Status"
                      name="referral_status"
                      options={Object.keys(REFERRAL_STATUS).map((key) => ({
                        label: key,
                        value: REFERRAL_STATUS[key],
                      }))}
                      selectedValue={values.referral_status}
                      handleChange={(obj) =>
                        setFieldValue("referral_status", obj.value)
                      }
                      error={
                        <ErrorMessage
                          className="error-message"
                          component="p"
                          name="referral_status"
                        />
                      }
                    />
                  </div>
                  <div className="col-sm-6">
                    <SelectComponent
                      isRequired
                      label="Existing Program Enrollments"
                      name="programe_enrollement"
                      options={programTypes}
                      selectedValue={values.programe_enrollement}
                      isMulti
                      handleChange={(arr) =>
                        setFieldValue("programe_enrollement", arr)
                      }
                      error={
                        <ErrorMessage
                          className="error-message"
                          component="p"
                          name="programe_enrollement"
                        />
                      }
                    />
                  </div>

                  <div className="col-sm-6">
                    <AsyncSelect
                      isRequired
                      label="Referral Source"
                      options={organizationList?.map((el) => ({
                        ...el,
                        value: el.id,
                        label: el.name,
                      }))}
                      dataCallback={(inputValue) =>
                        new Promise((resolve) => {
                          debouncedFetchOrganizationData(
                            inputValue,
                            (options) => {
                              if (!options || options.length === 0) {
                                resolve([]);
                              } else {
                                resolve(options);
                              }
                            }
                          );
                        })
                      }
                      placeholder="Select Referral"
                      handleChange={(selectedOption) => {
                        setSelectedReferralSource(selectedOption);
                        setFieldValue(
                          "referral_source",
                          selectedOption?.label || ""
                        );
                        setFieldValue(
                          "community_engagement_id",
                          selectedOption?.value || ""
                        );
                        setFieldValue("referring_provider", "");
                        setFieldValue("referral_contact_id", "");
                      }}
                      selectedValue={
                        values.referral_source
                          ? {
                              value: values.community_engagement_id,
                              label: values.referral_source,
                            }
                          : null
                      }
                      name="referral_source"
                      error={
                        <ErrorMessage
                          className="error-message"
                          component="p"
                          name="referral_source"
                        />
                      }
                    />
                  </div>
                  <div className="col-sm-6">
                    <AsyncSelect
                      isRequired
                      label="Referral Provider"
                      isMulti={false}
                      options={
                        selectedReferralSource?.organization_contacts?.map(
                          (contact) => ({
                            value: contact.id,
                            label: contact.name,
                          })
                        ) || []
                      }
                      dataCallback={(inputValue) =>
                        new Promise((resolve) => {
                          debouncedFetchOrganizationData(
                            inputValue,
                            (options) => {
                              const filteredOptions = options
                                .filter(
                                  (org) =>
                                    org.value === values.community_engagement_id
                                )
                                .flatMap(
                                  (org) =>
                                    organizationList
                                      .find((o) => o.id === org.value)
                                      ?.organization_contacts.map(
                                        (contact) => ({
                                          value: contact.id,
                                          label: contact.name,
                                        })
                                      ) || []
                                );
                              resolve(filteredOptions);
                            }
                          );
                        })
                      }
                      placeholder="Select..."
                      handleChange={(selectedOption) => {
                        setFieldValue(
                          "referring_provider",
                          selectedOption?.label || ""
                        );
                        setFieldValue(
                          "referral_contact_id",
                          selectedOption?.value || ""
                        );
                      }}
                      selectedValue={
                        values.referring_provider
                          ? {
                              value: values.referral_contact_id,
                              label: values.referring_provider,
                            }
                          : null
                      }
                      name="referring_provider"
                      isDisabled={!selectedReferralSource}
                      error={
                        <ErrorMessage
                          className="error-message"
                          component="p"
                          name="referring_provider"
                        />
                      }
                    />
                  </div>
                  <div className="col-sm-6">
                    <SelectComponent
                      isRequired
                      label="Referral Program"
                      name="referral_programe"
                      options={programTypes}
                      selectedValue={values.referral_programe}
                      handleChange={(obj) =>
                        setFieldValue("referral_programe", obj.value)
                      }
                      error={
                        <ErrorMessage
                          className="error-message"
                          component="p"
                          name="referral_programe"
                        />
                      }
                    />
                  </div>
                  <div className="col-sm-6">
                    <Input
                      handleChange={handleChange}
                      placeholder="e.g. Number"
                      type="text"
                      label="IF Number"
                      value={values.if_number}
                      name="if_number"
                      error={
                        <ErrorMessage
                          className="error-message"
                          component="p"
                          name="if_number"
                        />
                      }
                    />
                  </div>
                </div>
                <div className="col-sm-12">
                  <SelectComponent
                    label="Current Living Situation"
                    isRequired
                    options={CURRENT_LIVING_SITUATION}
                    selectedValue={values.current_living_situation}
                    placeholder="Current Living Situation"
                    handleChange={(obj) => {
                      setFieldValue("current_living_situation", obj.value);
                    }}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="current_living_situation"
                      />
                    }
                  />
                </div>
              </div>
              {values.referral_status === REFERRAL_STATUS.Denied && (
                <div className="col-sm-12">
                  <Input
                    isRequired
                    handleChange={handleChange}
                    placeholder="Reason..."
                    type="text"
                    label="Denial Reason"
                    value={values.denial_reason}
                    name="denial_reason"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="denial_reason"
                      />
                    }
                  />
                </div>
              )}
              <div className="col-sm-12">
                <Input
                  type="file"
                  accept=".pdf,.png,.jpeg,.jpg"
                  handleChange={(e) => {
                    const file = e.target.files[0];
                    if (!file) return;
                    setFieldValue("attachment", file);
                    setFieldValue("file_name", file?.name);
                    setFieldValue("content_type", file?.type);
                  }}
                  value={undefined}
                  label="Attachment"
                  name="attachment"
                  className="mb-1"
                />
                {
                  <ErrorMessage
                    style={{
                      fontSize: "0.775rem",
                      color: "red",
                    }}
                    component="p"
                    name="attachment"
                  />
                }
              </div>

              {selectedReferral?.attachment_file && (
                <div className="mt-2">
                  <div className="d-flex items-center gap-2">
                    <a
                      href={
                        selectedReferral?.attachment_file instanceof File
                          ? URL.createObjectURL(
                              selectedReferral?.attachment_file
                            )
                          : selectedReferral?.attachment_file
                      }
                      download
                      className="text-blue-500 cursor-pointer flex items-center gap-1"
                    >
                      <DownloadSimple size={25} /> {selectedReferral?.file_name}
                    </a>

                    {/* Copy Link Button */}
                    {/* <CopyLink
                      link={
                        selectedReferral?.attachment_url instanceof File
                          ? URL.createObjectURL(
                              selectedReferral?.attachment_url
                            )
                          : selectedReferral?.attachment_url
                      }
                    /> */}
                  </div>
                </div>
              )}

              {values.referral_status === REFERRAL_STATUS.Approved && (
                <div>
                  <h4 className="my-4">Authorization Information</h4>
                  <div className="input-flex row">
                    <div className="col-sm-6">
                      <Input
                        handleChange={handleChange}
                        placeholder="Auth Number..."
                        type="text"
                        isRequired
                        label="Authorization Number"
                        value={values.auth_number}
                        name="auth_number"
                        error={
                          <ErrorMessage
                            className="error-message"
                            component="p"
                            name="auth_number"
                          />
                        }
                      />
                    </div>
                    <div className="col-sm-6">
                      <DateInput
                        handleChange={(date) => {
                          setFieldValue("start_date", date);
                        }}
                        value={values.start_date}
                        isRequired
                        dateFormat="MM/DD/YYYY"
                        label="Authorization Start Date"
                        name="start_date"
                        placeholder="Auth Start Date.."
                        error={
                          <ErrorMessage
                            className="error-message"
                            component="p"
                            name="start_date"
                          />
                        }
                      />
                    </div>
                    <div className="col-sm-6">
                      <DateInput
                        handleChange={(date) => {
                          setFieldValue("end_date", date);
                        }}
                        value={values.end_date}
                        isRequired
                        label="Authorization End Date"
                        name="end_date"
                        placeholder="Auth End Date.."
                        error={
                          <ErrorMessage
                            className="error-message"
                            component="p"
                            name="end_date"
                          />
                        }
                      />
                    </div>
                    <div className="col-sm-6">
                      <Input
                        handleChange={handleChange}
                        placeholder="No. of Approved Days.."
                        isRequired
                        type="text"
                        label="Number of Approved Days"
                        value={values.approved_days}
                        name="approved_days"
                        error={
                          <ErrorMessage
                            className="error-message"
                            component="p"
                            name="approved_days"
                          />
                        }
                      />
                    </div>
                  </div>
                </div>
              )}
              <div className="action gap-2">
                <button
                  className="secondary-btn w-50"
                  type="button"
                  onClick={handleCloseAddModal}
                >
                  Cancel
                </button>
                <input
                  className="primary-btn w-50"
                  type="submit"
                  name="submit"
                  value={`${selectedReferral ? "Edit" : "Add"} Referral`}
                />
              </div>
            </form>
          </div>
        );
      }}
    </Formik>
  );
};

export default AddFromWithMember;
